<div class="row">
  <div class="col col-1 bold">
    @if (isRechtspersoon) {
      <span>Eigen vermogen</span>
    }
  </div>
  <div class="col-2 bold">
    Huidige periode
  </div>
  <div class="col-3 bold">
    Vorige periode
  </div>
</div>
<div class="pt-3"></div>
<form [formGroup]="totalShareCapitalFg">
  @if (isRechtspersoon && isEnkelvoudig && heeftAandelen) {
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Gestort en opgevraagd {{ isCooperatie ? "ledenkapitaal" : "aandelenkapitaal"}}</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"

        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  }
</form>
<form [formGroup]="totalSharePremiumFg">
  @if (isRechtspersoon && isEnkelvoudig && heeftAandelen) {
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Agio</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  }
</form>
<form [formGroup]="totalRevaluationReserveFg">
  @if (isRechtspersoon && isEnkelvoudig && heeftAandelen) {
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Herwaarderingsreserve</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  }
</form>
<form [formGroup]="totalLegalReservesFg">
  @if (isRechtspersoon && isEnkelvoudig && heeftAandelen) {
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Andere wettelijke reserves</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  }
</form>
<form [formGroup]="totalStatutoryReservesFg">
  @if (isRechtspersoon && isEnkelvoudig && heeftAandelen) {
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Statutaire reserves</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  }
</form>
<form [formGroup]="totalReinvestmentReserveFg">
  @if (isRechtspersoon && isEnkelvoudig && isFiscaleGrondslagen) {
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Herinvesteringsreserve</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  }
</form>
<form [formGroup]="totalReservesOtherFg">
  @if (isRechtspersoon && isEnkelvoudig) {
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Overige reserves</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  }
</form>
<form [formGroup]="totalOtherFiscalReservesFg">
  @if (isRechtspersoon && isEnkelvoudig && isFiscaleGrondslagen) {
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Overige fiscale reserves</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  }
</form>
<form [formGroup]="totalResultForTheYearFg">
  @if (isRechtspersoon && isEnkelvoudig && !isBalansNaResultaatbestemming) {
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Resultaat na belastingen van het boekjaar</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  }
</form>
<form [formGroup]="totalRetainedEarningsFg">
  @if (isRechtspersoon && isEnkelvoudig) {
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Niet verdeelde winsten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  }
</form>
<form [formGroup]="totalEquityFg">
  @if (isEnkelvoudig) {
    <div class="row">
      <div class="col col-1">
        @if (isRechtspersoon) {
          <p style="padding: 6px"><b>Totaal van eigen vermogen</b></p>
        }
        @if (!isRechtspersoon) {
          <p>Eigen vermogen</p>
        }
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  }
</form>
<form [formGroup]="totalNoncontrollingInterestFg">
  @if (isRechtspersoon && !isEnkelvoudig) {
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Aandeel van derden in groepsmaatschappijen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  }
</form>
<form [formGroup]="totalEquityGroupFg">
  @if (isRechtspersoon && !isEnkelvoudig) {
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Groepsvermogen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  }
</form>
<!--<div class="row pt-3">-->
<!--    <div class="col col-1 bold">-->
<!--    </div>-->
<!--    <div class="col-2 bold">-->
<!--    </div>-->
<!--    <div class="col-2 bold">-->
<!--    </div>-->
<!--  </div>-->

@if (isRechtspersoon) {
  <div class="pt-3"></div>
}

<form [formGroup]="totalVoorzFg">
  <div class="row">
    <div class="col col-1">
      <p>Voorzieningen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalLangFg">
  <div class="row">
    <div class="col col-1">
      <p>Langlopende schulden</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalKortFg">
  <div class="row">
    <div class="col col-1">
      <p>Kortlopende schulden</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalEquityAndLiabilitiesFg">
  <div class="row pt-3">
    <div class="col col-1">
      <p><b>Totaal van passiva</b></p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
